import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HeaderService } from '../header.service';
import RoutesserviceService from '../routesservice.service';

@Injectable({
  providedIn: 'root'
})
export class AttendanceReportService {
  constructor(
    private httpClient: HttpClient,
    private customerRoutes: RoutesserviceService,
    private headerService: HeaderService
  ) {}

  getAttendanceReport(month: string) {
    return this.httpClient.get(
      `${this.customerRoutes.getAttendanceReports()}?month=${encodeURIComponent(month)}`,
      {
        headers: this.headerService.getHeaderWithToken(localStorage.getItem('token')),
      }
    );
  }
}
